<div class="card-veiculo marginT30 form-group tab-buttons">
  <div>
    <span class="card-veiculo_title">{{ title }}</span>
    <button *ngIf="!hasIdSimulacao || hasIdSimulacao && (hasPendencia && index || !veiculo.inSimular && index)"
      type="button" class="close" aria-label="Close" (click)="onClickRemove()">
      <span aria-hidden="true">&times;</span>
    </button>
    <button *ngIf="(!hasIdSimulacao || hasIdSimulacao && (hasPendencia || !veiculo.inSimular)) || isGaratiaRecusada"
      type="button" class="close card-veiculo_btn-edit" aria-label="Edit" [disabled]="hasAnyEdit"
      (click)="onClickEdit()">
      <span class="glyphicon glyphicon-pencil"></span>
    </button>
  </div>
  <span *ngIf="hasPendencia" class="card-veiculo_subtitle">
    {{ descricaoPendencia }}
  </span>
  <div *ngIf="isZeroKm" [ngClass]="{'card-veiculo_pendencia': hasPendencia}" class="card-veiculo_descricao">
    <span>{{ descricao }}</span>
  </div>
  <div *ngIf="isZeroKm" class="card-veiculo_valor">
    <span>R$ {{ veiculo.cotacao | number:'1.2-2' }}</span>
  </div>

  <div *ngIf="!isZeroKm" class="card-veiculo_info">
    <dl class="card-veiculo_info_label">
      <dt>Placa</dt>
      <dd [ngClass]="{'card-veiculo_pendencia': hasPendencia}">
        {{ veiculo.veiculoPlaca }}
      </dd>
    </dl>
    <dl *ngIf="estadoLicenciamento" class="card-veiculo_info_label">
      <dt>Estado de Licenciamento</dt>
      <dd>{{ estadoLicenciamento }}</dd>
    </dl>
    <dl *ngIf="estadoLicenciamento" class="card-veiculo_info_label">
      <dt>Util. Agro.</dt>
      <dd>{{ veiculo.isUtilizacaoAgropecuaria ? 'Sim' : 'Não' }}</dd>
    </dl>
  </div>

  <div *ngIf="(!hasIdSimulacao || hasIdSimulacao && (hasPendencia || !veiculo.inSimular)) && !isGaratiaRecusada"
    class="card-veiculo_actions">
    <div *ngIf="hasPendencia" class="row ficha-veiculo-lista_btn">
      <a (click)="onClickEdit()" class="bt-back btn btn-border-orange pull-left">
        Alterar Placa
      </a>
    </div>

    <div *ngIf="hasPendencia" class="row ficha-veiculo-lista_btn">
      <a (click)="onClickEdit(true)" class="bt-back btn btn-border-orange pull-left">
        Informar Veículo
      </a>
    </div>
  </div>
</div>
